export default __webpack_public_path__ + "static/media/addResourceWhite.7ff57ff3.svg";